export default "__VITE_ASSET__8830c2cf__"